import { toast } from 'react-toastify';

const requestLoginType = 'REQUEST_LOGIN';
const receiveLoginType = 'RECEIVE_LOGIN';
const signOutType = 'SIGN_OUT';

const initialState = {
    auth: {
        user: JSON.parse(localStorage.getItem('user')), token: localStorage.getItem('token')
    },
    isAuthenticated: localStorage.getItem('user') !== null,// if we wanted to add an explicit expiration time to our token && new Date().getTime() < JSON.parse(localStorage.getItem('user')).expires,
    authFailed: false,
    userRole: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).primaryRole : '',
    userRelationshipType: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).userRelationshipType : null,
    reportGroupHash: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).reportGroupHash : null
};

export const actionCreators = {
    requestLoginToken: (username, password) => async (dispatch, getState) => {

        dispatch({ type: requestLoginType, username, password });

        const url = `api/token/tokenlogin`;
        const fetchConfig = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify({ username: username, password: password })
        };
        const response = await fetch(url, fetchConfig);
        if (response.ok) {

            const auth = await response.json();

            // should this go in the reducer code? [BDL - I don't think so, might be timing issues]
            let user = JSON.stringify(auth.user);
            localStorage.setItem('user', user);
            localStorage.setItem('token', auth.token);
            localStorage.setItem('refreshToken', auth.refreshToken);

            dispatch({ type: receiveLoginType, auth, authFailed: false });
        }
        else if (response.status === 401) {
            toast.error("Invalid User Name or Password.");
            dispatch({ type: receiveLoginType, auth: initialState.auth, authFailed: true });
        }
        else {
            let msg = await response.text();
            toast.error(msg);
            dispatch({ type: receiveLoginType, auth: initialState.auth, authFailed: true });
        }

    },

    signOut: () => async (dispatch, getState) => {
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        dispatch({ type: signOutType });
    }
};

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === requestLoginType) {
        return {
            ...state
        };
    }

    if (action.type === receiveLoginType) {
        let user = JSON.parse(localStorage.getItem('user'));
        return {
            ...state,
            auth: action.auth,
            isAuthenticated: action.auth.user !== null && !action.authFailed,
            authFailed: action.authFailed,
            userRole: user ? user.primaryRole : '',
            userRelationshipType: user ? user.userRelationshipType : null,
            reportGroupHash: user ? user.reportGroupHash : null
        };
    }

    if (action.type === signOutType) {
        return {
            ...state,
            isAuthenticated: false,
            authFailed: false,
            auth: null
        };
    }


    return state;
};



// WEBPACK FOOTER //
// ./src/store/LoginActionsReducers.js